import home1YinliuLogo from '@/assets/img/home1_yinliu_logo.png'
import daichao1 from '@/assets/img/daichao1.png'
export default {
  data () {
    return {
      //  引导页\贷超\被拒引流产品名称
      productName: 'Rise Dana',
      //  引导页\贷超\被拒下载链接
      downloadUrl: 'https://apps.apple.com/id/app/rise-dana-pinjaman-dana/id6770406906?l=id&uo=4',
      // BRD链接
      brdDownloadUrl: `https://www.cashcash.cc/brd?tm=${Date.now()}`,
      home1_yinliu_logo: home1YinliuLogo,
      daichao1: daichao1
    }
  },
  methods: {

  }
}
